const translations = {
  AssignmentMenu: {
    CurrentAssignments: 'Current'
  },
  CourseTreeLeaf: {
    studentPreview: ' Preview',
  },
  Login: {
    buttonSignUpLabel: 'Sign Up',
    forgotPassword: 'Forgot password',
    loginLogoLabel: 'Logo: Gladeo®'
  },
  StudentDashboard: {
    BookLabel: 'My Content',
    WelcomeLabel: 'Welcome,'
  },
  StudentTopNav: {
    BookLabel: 'My Content'
  },
  TeacherDashboard: {
    WelcomeLabel: 'Welcome,'
  }
};

export default translations;
